// src/components/portfolio/add-asset/components/SearchResults.js
import React from 'react';
import CurrencyIcon from '../utils/icons/CurrencyIcon';
import StockIcon from '../utils/icons/StockIcon';

const SearchResults = ({ results, searchMode, onSelect }) => {
  if (results.length === 0) return null;

  const getResultIcon = (result) => {
    switch (searchMode) {
      case 'currency':
        return <CurrencyIcon symbol={result.symbol} />;
      case 'fund':
        return <StockIcon symbol={result.symbol} symbolInfo={{ type: 'FUND' }} />;
      default:
        return <StockIcon symbol={result.symbol} symbolInfo={result} />;
    }
  };

  const getSecondaryText = (result) => {
    switch (searchMode) {
      case 'currency':
        return result.symbol;
      case 'fund':
        return result.info?.fundType || 'TEFAS Fonu';
      default:
        return result.exchangeShortName || '';
    }
  };

  return (
    <ul className="mt-1 border rounded-md divide-y max-h-48 overflow-y-auto dark:border-gray-700 dark:divide-gray-700">
      {results.map((result) => (
        <li
          key={result.symbol}
          className="px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer bg-white dark:bg-gray-800"
          onClick={() => onSelect(result)}
        >
          <div className="flex items-center space-x-3">
            {getResultIcon(result)}
            <div className="flex-1 min-w-0">
              <div className="font-medium text-gray-900 dark:text-gray-100">
                {result.symbol}
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400 truncate">
                {result.name}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-500">
                {getSecondaryText(result)}
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default SearchResults;